
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getOperationDetail } from "@/api/api-non-name";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiHairpinManage extends Vue {
  private formInline: objAny = {
    cardPkId: "",
    globalPageIndex: 1,
    globalPageSize: 10
  };
  private cardPkId = "";
  private total = 0;
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("nonFundHistory.createName"),
      key: "createUserName",
      minWidth: 110
    },
    {
      title: i18n.t("nonFundHistory.time"),
      key: "createTime",
      minWidth: 130
    },
    {
      title: i18n.t("operate"),
      key: "operateTypeDesc",
      width: 260,
      align: "center"
    }
  ];

  public tableChange(val: number) {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public tableSizeChange(val: number) {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  async getTableList() {
    const ret = await getOperationDetail(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.tableList = ret.data;
      this.total = ret.data.length;
    }
  }
  mounted() {
    const item = this["$common"].get("non-real-name-card-management-item");
    this.formInline.cardPkId = item.cardPkId;
    this.getTableList();
  }
}
